import "./style.css";
import data from "../static/json/data.json";
import waterVertex from "./shader/water/vertex.glsl";
import waterFragment from "./shader/water/fragment.glsl";
import godRayVertex from "./shader/godRay/vertex.glsl";
import godRayFragment from "./shader/godRay/fragment.glsl";
import particleVertex from "./shader/particle/vertex.glsl";
import particleFragment from "./shader/particle/fragment.glsl";
import deepSeaVertex from "./shader/deepSea/vertex.glsl";
import deepSeaFragment from "./shader/deepSea/fragment.glsl";
import fishVertex from "./shader/fish/vertex.glsl";
import fishFragment from "./shader/fish/fragment.glsl";
import positionShader from "./shader/fish/position.glsl";
import velocityShader from "./shader/fish/velocity.glsl";
import velocityShader2 from "./shader/fish/velocity2.glsl";

import * as THREE from 'three';
// import * as SkeletonUtils from 'three/examples/jsm/utils/SkeletonUtils.js';
import Stats from 'three/examples/jsm/libs/stats.module.js';
import { GUI } from 'three/examples/jsm/libs/lil-gui.module.min.js';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js';
import { RGBELoader } from "three/examples/jsm/loaders/RGBELoader.js";
import { GPUComputationRenderer } from 'three/examples/jsm/misc/GPUComputationRenderer.js';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';

import { gsap } from "gsap";
import { CustomEase } from "gsap/CustomEase";
gsap.registerPlugin( CustomEase );

import {
    apiGetPeopleData,
    apiGetSpinStatus,
    apiPostPicSave,
    apiGetPicSaved,
    apiPostSpinStatus
} from "./api";

import * as Sentry from "@sentry/browser";
import { BrowserTracing } from "@sentry/tracing";

let config = {};
const getJSON = async url => {

    const response = await fetch( url );
    if ( !response.ok ) throw new Error( response.statusText );
    return response.json();

};

getJSON( "./json/config.json" )
    .then( data => config = data )
    .catch( error => console.error( error ) )
    .finally( () => {

        Sentry.init( {
            dsn: "https://607535b76b1e461692a59ac4505f36cc@o1351354.ingest.sentry.io/6631857",
            integrations: [ new BrowserTracing() ],

            // Set tracesSampleRate to 1.0 to capture 100%
            // of transactions for performance monitoring.
            // We recommend adjusting this value in production
            tracesSampleRate: 1.0,
        } );


        // TEXTURE WIDTH FOR SIMULATION
        const WIDTH = 64;
        const BIRDS = WIDTH * WIDTH;

        // BAKE ANIMATION INTO TEXTURE and CREATE GEOMETRY FROM BASE MODEL
        const BirdGeometry = new THREE.BufferGeometry();
        let textureAnimation, durationAnimation,
            birdMesh, backgroundBird,
            materialShader, materialShader2,
            indicesPerBird,
            maxArea = 0;

        // whale model
        let meshes = [],
            initialPoints = [ [], [], [], [], [] ],
            curveRoads = [],
            whale,
            mixer;

        // other marine lifes
        let lifes = [],
            mixers = [];

        // particle
        let particleGeometry,
            particleMaterial,
            particle,
            segment = [ 0, 9, 25, 40, 49, 78 ],
            countArr = [ 0, 50, 100, 180, 230, 330 ],
            areaArr = [ { x: -3.5, y: 6 }, { x: -6.5, y: -2.3 }, { x: 5, y: 5 }, { x: 3.5, y: -5.5 } ],
            resArea = [ 3, 2, 0, 1 ],
            areaCount = [ 0, 0, 0, 0, 0 ],
            lastAreaCount = [ 0, 0, 0, 0, 30 ],
            segCount = 5,
            amount = config.particleNum || 120,
            number = 330;

        // ocean
        let waterMaterial, godrayMaterial;

        // floatings
        let floatings = [],
            floatingMaterials = [],
            floatingTotal = 512;

        let group,
            deepSea,
            cameraCurve,
            lines = [],
            balls = [];

        let backgroundObject = {},
            lightObject = {},
            waterObject = {},
            deepSeaObject = {},
            whaleObject = {},
            fishObject = {},
            floatingObject = {},
            backgroundFishObject = {},
            otherSetting = {},
            timingObject = {},
            gui, otherFolder;

        let debug = config.debug || false;

        // let leftBorderWidth = 0;
        // let rightBorderWidth = 0;
        // let leftBorderWidth = ( window.innerWidth - window.innerHeight * 9 / 16 ) / 2;
        // let rightBorderWidth = ( window.innerWidth - window.innerHeight * 9 / 16 ) / 2;
        let leftBorderWidth = window.innerWidth < 568 ? 0 : ( window.innerWidth - window.innerHeight * 9 / 16 ) / 2;
        let rightBorderWidth = window.innerWidth < 568 ? 0 : ( window.innerWidth - window.innerHeight * 9 / 16 ) / 2;
        let topBorderWidth = 0;
        let bottomBorderWidth = 0;

        // const marineLife = [ "BottlenoseDolphin", "GreenSeaTurtle", "KillerWhale", "RissoDolphin", "SpermWhale", "SpinnerDolphin" ];
        const marineLife = [ "GreenSeaTurtle", "SpermWhale" ];
        // const marineLifeSize = [ 1.7, 0.1, 0.95, 1, 1, 1.7 ];
        const marineLifeSize = [ 0.1, 1 ];
        const marineLifeAnimationDuration = { BottlenoseDolphin: 130, GreenSeaTurtle: 20, KillerWhale: 60, RissoDolphin: 160, SpermWhale: 120, SpinnerDolphin: 150 };
        // const marineLifeIndex = [ 0, 1, 2, 3, 4, 5 ];
        // const marineLifeIndex = [ 0, 1 ];

        const manager = new THREE.LoadingManager();
        const loader = new GLTFLoader( manager );
        const dracoLoader = new DRACOLoader();
        const rgbeLoader = new RGBELoader();
        const textureLoader = new THREE.TextureLoader();

        const ratio = Math.E / 0.8;

        let d = 0,
            interval = 0,
            status = "Status is normal, no one call spin!";

        let dataLoop = false,
            spinLoop = false,
            imageLoop = false;

        dracoLoader.setDecoderPath( './draco/' );
        loader.setDRACOLoader( dracoLoader );


        // settings
        const toneMapping = {
            No: THREE.NoToneMapping,
            Linear: THREE.LinearToneMapping,
            Reinhard: THREE.ReinhardToneMapping,
            Cineon: THREE.CineonToneMapping,
            ACESFilmic: THREE.ACESFilmicToneMapping
        };

        backgroundObject.color = 0x000000;
        backgroundObject.filterColor = 0x000000;
        backgroundObject.filterOpacity = 0.15;

        lightObject.lightColor = 0x002242;
        lightObject.lightGroundColor = 0x2c6590;
        lightObject.lightIntensity = 3;
        lightObject.toneMapping = "Cineon";
        lightObject.toneMappingExposure = 0.8;

        waterObject.depthColor = 0x0c2027;
        waterObject.surfaceColor = 0x000419;
        waterObject.fogColor = 0x010911;

        deepSeaObject.color1 = 0x000000;
        deepSeaObject.color2 = 0x001d4d;
        deepSeaObject.offsetX = 0.46;
        deepSeaObject.offsetY = -0.146;
        deepSeaObject.scaleX = 1.727;
        deepSeaObject.scaleY = 0.328;

        whaleObject.size = 0.089;
        whaleObject.x = 0;
        whaleObject.y = 0.15;
        whaleObject.particleCount1 = 0;
        whaleObject.particleCount2 = 0;
        whaleObject.particleCount3 = 0;
        whaleObject.particleCount4 = 0;
        whaleObject.particleCount5 = 0;
        whaleObject.particleCount5Lowest = 30;
        whaleObject.showPic = showPic;
        whaleObject.makeWhaleSpin = makeWhaleSpin;

        fishObject.separation = 0.5;
        fishObject.alignment = 0.3;
        fishObject.cohesion = 0.5;
        fishObject.freedom = 0.75;
        fishObject.size = 1.5;
        fishObject.count = Math.floor( BIRDS / 4 ) / 8;
        fishObject.centerX = 5;
        fishObject.centerY = 0.5;
        fishObject.centerZ = 0;
        fishObject.colorR = -0.17;
        fishObject.colorG = -0.1;
        fishObject.colorB = -0.02;
        fishObject.centering = 80.0;

        floatingObject.size = 1;
        floatingObject.z = 0;

        backgroundFishObject.separation2 = 12;
        backgroundFishObject.alignment2 = 0;
        backgroundFishObject.cohesion2 = 1;
        backgroundFishObject.freedom2 = 0.75;
        backgroundFishObject.size2 = 1;
        backgroundFishObject.count2 = 256;

        otherSetting.opacity = ( config.opacityLimit == undefined ? 0.75 : config.opacityLimit );
        otherSetting.waveCamera = false;
        otherSetting.isFullScreen = true;
        otherSetting.turtleAppear = false;
        otherSetting.whaleAppear = true;

        timingObject.value = 0;


        // 下一個 2 的平方數 
        function nextPowerOf2 ( n ) {

            return Math.pow( 2, Math.ceil( Math.log( n ) / Math.log( 2 ) ) );

        }

        // Float32 Array concat
        function Float32Concat ( first, second ) {

            const firstLength = first.length;
            const result = new Float32Array( firstLength + second.length );

            result.set( first );
            result.set( second, firstLength );

            return result;

        }

        // 插值
        Math.lerp = function ( value1, value2, amount ) {

            amount = Math.max( Math.min( amount, 1 ), 0 );
            return value1 + ( value2 - value1 ) * amount;

        };

        Math.cauchyRandom = function ( a, b ) {

            let u, cauchy;

            u = Math.random();
            cauchy = a - b / Math.tan( Math.PI * u );

            return cauchy;

        };

        Math.normalRandom = function ( mean, std ) {

            let u = 0, v = 0, w = 0, c = 0;

            do {
                u = Math.random() * 2 - 1;
                v = Math.random() * 2 - 1;
                w = u * u + v * v;
            } while ( w == 0 || w >= 1 );

            c = Math.sqrt( ( -2 / Math.log( w ) ) / w );

            let normal = mean + ( u * c ) * std;
            return normal;

        };

        Math.maxMin = function ( low, high, val ) {

            return Math.min( Math.max( low, val ), high );

        };

        Math.logNormal = function ( mu, sigma ) {

            let u = 0, v = 0, s;

            do {

                u = Math.random() * 2 - 1;
                v = Math.random() * 2 - 1;
                s = u * u + v * v;

            } while ( s === 0 || s > 1 );

            let c = Math.sqrt( -2 * Math.log( s ) / s ),
                x = u * c,
                y = v * c;
            x = mu + x * sigma;
            y = mu + y * sigma;

            return Math.exp( x );

        };

        Math.randomNum = function () {

            return Math.round( Math.random() * 100 ) / 100;

        };

        Math.shuffle = function ( array ) {

            for ( let i = array.length - 1; i > 0; i-- ) {

                let j = Math.floor( Math.random() * ( i + 1 ) );
                [ array[ i ], array[ j ] ] = [ array[ j ], array[ i ] ];

            }

        };

        // ocean top
        const waterGeometry = new THREE.PlaneBufferGeometry( 6, 2, 128, 128 );
        waterMaterial = new THREE.ShaderMaterial( {

            uniforms: {

                uResolution: {
                    value: new THREE.Vector2(
                        window.innerWidth - leftBorderWidth - rightBorderWidth,
                        window.innerHeight - topBorderWidth - bottomBorderWidth
                    )
                },
                uTime: { value: 0 },

                uBigWavesElevation: { value: 0.03 },
                uBigWavesFrequency: { value: new THREE.Vector2( 2.0, 10.0 ) },
                uBigWavesSpeed: { value: 1.5 },

                uSmallWavesElevation: { value: 0.02 },
                uSmallWavesFrequency: { value: 24 },
                uSmallWavesSpeed: { value: 0.6 },
                uSmallWavesInteraction: { value: 1.0 },

                uDepthColor: { value: new THREE.Color( waterObject.depthColor ) },
                uSurfaceColor: { value: new THREE.Color( waterObject.surfaceColor ) },
                uFogColor: { value: new THREE.Color( backgroundObject.color ) },
                uColorOffset: { value: 0.0 },
                uColorMultiplier: { value: 10.0 }

            },

            vertexShader: waterVertex,
            fragmentShader: waterFragment,
            side: THREE.DoubleSide,
            depthTest: false

        } );

        const water = new THREE.Mesh( waterGeometry, waterMaterial );
        water.position.y = 0.75;
        water.rotation.x = Math.PI * 0.3;
        water.visible = false;

        const godrayGeometry = new THREE.PlaneBufferGeometry( 6, 2, 16, 16 );
        godrayMaterial = new THREE.ShaderMaterial( {

            uniforms: {

                uResolution: {
                    value: new THREE.Vector2(
                        window.innerWidth - leftBorderWidth - rightBorderWidth,
                        window.innerHeight - topBorderWidth - bottomBorderWidth
                    )
                },
                uTime: { value: 0 },
                side: THREE.DoubleSide

            },

            vertexShader: godRayVertex,
            fragmentShader: godRayFragment,
            blending: THREE.AdditiveBlending,
            depthTest: false,

        } );

        const godrayMesh = new THREE.Mesh( godrayGeometry, godrayMaterial );
        godrayMesh.position.z = 1.2;
        godrayMesh.position.y = 0;
        godrayMesh.visible = false;

        const deepSeaGeometry = new THREE.PlaneGeometry( 200, 200 );
        const deepSeaMaterial = new THREE.RawShaderMaterial( {

            uniforms: {
                time: { type: "f", value: 0 },
                aspectCorrection: { type: 'i', value: false },
                aspect: { type: 'f', value: 1 },
                offset: { type: 'v2', value: new THREE.Vector2( deepSeaObject.offsetX, deepSeaObject.offsetY ) },
                scale: { type: 'v2', value: new THREE.Vector2( deepSeaObject.scaleX, deepSeaObject.scaleY ) },
                smooth: { type: 'v2', value: new THREE.Vector2( 0, 1 ) },
                color1: { type: 'c', value: new THREE.Color( deepSeaObject.color1 ) },
                color2: { type: 'c', value: new THREE.Color( deepSeaObject.color2 ) },
                alpha: { type: "f", value: 1 }
            },

            vertexShader: deepSeaVertex,
            fragmentShader: deepSeaFragment,
            blending: THREE.AdditiveBlending,
            depthTest: true,
            depthWrite: false

        } );
        deepSea = new THREE.Mesh( deepSeaGeometry, deepSeaMaterial );
        deepSea.position.z = -50;
        deepSea.visible = false;


        for ( let idx in marineLife ) {

            const life = marineLife[ idx ];

            loader.load( `./models/${ life }.glb`, ( gltf ) => {

                const animal = gltf.scene;
                const animalMixer = new THREE.AnimationMixer( animal );
                animal.name = life;
                lifes.push( animal );
                mixers.push( animalMixer );

                const clip = gltf.animations[ 0 ];
                const action = animalMixer.clipAction( clip );
                action.play();

                const size = whaleObject.size * marineLifeSize[ idx ];
                animal.scale.set( size, size, size );

                let position = { x: 0, y: 0, z: 0 };

                if ( life === "GreenSeaTurtle" ) {

                    position.x = -0.06;
                    position.y = -0.04;
                    position.z = 1.9;

                    // position.x = -0.01;
                    // position.y = -0.02;

                    animal.scale.set( size * 0.8, size * 0.8, size * 0.8 );
                    animal.rotation.x = Math.PI * 0.5;
                    animal.rotation.y = Math.PI * 0.55;
                    animal.rotation.z = -Math.PI * 0.5;
                    animal.children[ 0 ].children[ 1 ].material.color = new THREE.Color( 0x69bdbf );

                } else {

                    position.x = 3.5;
                    position.y = 1;
                    position.z = -8;

                    // position.x = -1;
                    // position.y = 2;

                    animal.children[ 0 ].children[ 2 ].material.color = new THREE.Color( 0x406aa0 );
                    animal.rotation.y = -Math.PI * 0.5;

                }

                animal.position.set( position.x, position.y, position.z );

            } );

        }


        loader.load( "./models/whale.glb", ( gltf ) => {

            whale = gltf.scene;
            whale.position.y = whaleObject.y;
            whale.scale.set( whaleObject.size, whaleObject.size, whaleObject.size );
            whale.updateMatrixWorld();


            for ( let i = 0; i < segCount; i++ ) {

                let start = segment[ i ];
                let end = segment[ i + 1 ];
                let index = 0;

                for ( let j = start; j < end; j++ ) {

                    let curvePoint = new THREE.Vector3();
                    const mesh = whale.getObjectByName( `Cube${ j }` );
                    initialPoints[ i ].push( whale.localToWorld( curvePoint.copy( mesh.position ) ) );
                    mesh.visible = false;
                    mesh.segment = i;
                    mesh.sIndex = index;
                    meshes.push( mesh );
                    index++;

                }

                let curveRoad = new THREE.CatmullRomCurve3( initialPoints[ i ] );
                curveRoad.curveType = 'centripetal';
                curveRoad.closed = true;
                curveRoads.push( curveRoad );

            }


            mixer = new THREE.AnimationMixer( whale );
            for ( let clip of gltf.animations ) {

                const action = mixer.clipAction( clip );
                action.play();

            }


            let positions = new Float32Array( amount * 3 * number );
            let colors = [];
            let customPositions = [];
            let velocity = [];
            let alphas = [];
            let particleSizes = [];

            let color = new THREE.Color( 0xffffff );
            let sIndex = 0;
            let mIndex = -1;

            for ( let i = 0; i < amount * 3 * number; i = i + 3 ) {

                const index = i % ( amount * 3 );
                if ( index == 0 ) mIndex++;

                if ( i == amount * 3 * countArr[ 1 ] ) {
                    sIndex = 1;
                    mIndex = 0;
                }
                if ( i == amount * 3 * countArr[ 2 ] ) {
                    sIndex = 2;
                    mIndex = 0;
                }
                if ( i == amount * 3 * countArr[ 3 ] ) {
                    sIndex = 3;
                    mIndex = 0;
                }
                if ( i == amount * 3 * countArr[ 4 ] ) {
                    sIndex = 4;
                    mIndex = 0;
                }

                const v = index / ( amount * 3 );
                const r = Math.random() * 0.75 + 0.25;

                velocity.push( v );
                alphas.push( 0.0 );

                color.setHSL( r, 0.9, 1.0 );
                color.toArray( colors, i );

                particleSizes.push( Math.random() * 0.012 + 0.006 );

                const x = Math.maxMin( -0.05, 0.05, Math.cauchyRandom( 0, 1.22 ) * 0.008 );
                const y = Math.maxMin( -0.05, 0.05, Math.cauchyRandom( 0, 1.22 ) * 0.008 );
                const z = Math.maxMin( -0.05, 0.05, Math.cauchyRandom( 0, 1.22 ) * 0.008 );

                customPositions.push( x, y, z );

            }


            particleGeometry = new THREE.BufferGeometry();
            particleGeometry.setAttribute( "position", new THREE.BufferAttribute( positions, 3 ) );
            particleGeometry.setAttribute( "customColor", new THREE.Float32BufferAttribute( colors, 3 ) );
            particleGeometry.setAttribute( "customPosition", new THREE.Float32BufferAttribute( customPositions, 3 ) );
            particleGeometry.setAttribute( "velocity", new THREE.Float32BufferAttribute( velocity, 1 ) );
            particleGeometry.setAttribute( "alpha", new THREE.Float32BufferAttribute( alphas, 1 ) );
            particleGeometry.setAttribute( "size", new THREE.Float32BufferAttribute( particleSizes, 1 ) );


            const uniforms = {
                time: { value: 0.0 },
                opacityLimit: { value: otherSetting.opacity },
                color: { value: new THREE.Color( 0xffffff ) },
                pointTexture: { value: textureLoader.load( "./image/particle/snowflake1.png" ) }
            };

            particleMaterial = new THREE.ShaderMaterial( {

                uniforms,
                vertexShader: particleVertex,
                fragmentShader: particleFragment,
                blending: THREE.AdditiveBlending,
                depthTest: true,
                depthWrite: false,
                transparent: true

            } );

            particle = new THREE.Points( particleGeometry, particleMaterial );

            whale.visible = false;
            particle.visible = false;

        } );


        loader.load( "./models/fish.glb", function ( gltf ) {

            const animations = gltf.animations;
            const birdGeo = gltf.scene.children[ 0 ].geometry;
            const morphAttributes = birdGeo.morphAttributes.position;
            durationAnimation = Math.round( animations[ 0 ].duration * 60 );

            const tHeight = nextPowerOf2( durationAnimation );
            const tWidth = nextPowerOf2( birdGeo.getAttribute( 'position' ).count );
            const tData = new Float32Array( 4 * tWidth * tHeight );
            indicesPerBird = birdGeo.index.count;


            for ( let i = 0; i < tWidth; i++ ) {

                for ( let j = 0; j < tHeight; j++ ) {

                    const offset = j * tWidth * 4;

                    const curMorph = Math.floor( j / durationAnimation * morphAttributes.length );
                    const nextMorph = ( Math.floor( j / durationAnimation * morphAttributes.length ) + 1 ) % morphAttributes.length;
                    const lerpAmount = j / durationAnimation * morphAttributes.length % 1;

                    if ( j < durationAnimation ) {

                        let d0, d1;

                        d0 = morphAttributes[ curMorph ].array[ i * 3 ];
                        d1 = morphAttributes[ nextMorph ].array[ i * 3 ];

                        if ( d0 !== undefined && d1 !== undefined ) tData[ offset + i * 4 ] = Math.lerp( d0, d1, lerpAmount );

                        d0 = morphAttributes[ curMorph ].array[ i * 3 + 1 ];
                        d1 = morphAttributes[ nextMorph ].array[ i * 3 + 1 ];

                        if ( d0 !== undefined && d1 !== undefined ) tData[ offset + i * 4 + 1 ] = Math.lerp( d0, d1, lerpAmount );

                        d0 = morphAttributes[ curMorph ].array[ i * 3 + 2 ];
                        d1 = morphAttributes[ nextMorph ].array[ i * 3 + 2 ];

                        if ( d0 !== undefined && d1 !== undefined ) tData[ offset + i * 4 + 2 ] = Math.lerp( d0, d1, lerpAmount );

                        tData[ offset + i * 4 + 3 ] = 1;

                    }

                }

            }

            textureAnimation = new THREE.DataTexture( tData, tWidth, tHeight, THREE.RGBAFormat, THREE.FloatType );
            textureAnimation.needsUpdate = true;

            const vertices = [], color = [], reference = [], seeds = [], indices = [];
            const total = birdGeo.getAttribute( 'position' ).count * 3;
            const totalVertices = total * BIRDS;
            const uvs = new Array( totalVertices * 2 / 3 ).fill( 0 );
            let uvbIndex;

            for ( let i = 0; i < totalVertices; i++ ) {

                const bIndex = i % total;
                vertices.push( birdGeo.getAttribute( 'position' ).array[ bIndex ] );

                if ( uvbIndex !== Math.floor( bIndex * 2 / 3 ) ) {

                    uvbIndex = Math.floor( bIndex * 2 / 3 );
                    const uvCount = Math.floor( i / total );
                    const uvIndex = ( total * 2 / 3 ) * uvCount + uvbIndex;
                    uvs[ uvIndex ] = birdGeo.getAttribute( "uv" ).array[ uvbIndex ];

                }

            }

            for ( let m = 0; m < BIRDS; m++ ) {

                const r = Math.random() * 100;

                for ( let v = 0; v < total / 3; v++ ) {

                    color.push( 0.2 * r / 100 - 0.1 );

                }

            }

            let r = Math.random();
            for ( let i = 0; i < birdGeo.getAttribute( 'position' ).count * BIRDS; i++ ) {

                const bIndex = i % ( birdGeo.getAttribute( 'position' ).count );
                const bird = Math.floor( i / birdGeo.getAttribute( 'position' ).count );
                if ( bIndex == 0 ) r = Math.random();
                const j = ~ ~bird;
                const x = ( j % WIDTH ) / WIDTH;
                const y = ~ ~( j / WIDTH ) / WIDTH;
                reference.push( x, y, bIndex / tWidth, durationAnimation / tHeight );
                seeds.push( bird, r, Math.random(), Math.random() );

            }

            for ( let i = 0; i < birdGeo.index.array.length * BIRDS; i++ ) {

                const offset = Math.floor( i / birdGeo.index.array.length ) * ( birdGeo.getAttribute( 'position' ).count );
                indices.push( birdGeo.index.array[ i % birdGeo.index.array.length ] + offset );

            }

            BirdGeometry.setAttribute( 'position', new THREE.BufferAttribute( new Float32Array( vertices ), 3 ) );
            BirdGeometry.setAttribute( 'uv', new THREE.BufferAttribute( new Float32Array( uvs ), 2 ) );
            BirdGeometry.setAttribute( 'color', new THREE.BufferAttribute( new Float32Array( color ), 1 ) );
            BirdGeometry.setAttribute( 'reference', new THREE.BufferAttribute( new Float32Array( reference ), 4 ) );
            BirdGeometry.setAttribute( 'seeds', new THREE.BufferAttribute( new Float32Array( seeds ), 4 ) );
            BirdGeometry.setIndex( indices );

        } );


        manager.onLoad = () => {

            group = new THREE.Group();

            const pos = particle.geometry.getAttribute( "position" );
            const { array } = particle.geometry.getAttribute( "velocity" );
            const color = [ 0xb01c28, 0x3b5859, 0xc7a72e, 0xa68e8a, 0x410357 ];

            for ( let idx in curveRoads ) {

                const curve = curveRoads[ idx ];

                let start = amount * countArr[ idx ],
                    end = amount * countArr[ idx - 0 + 1 ];

                for ( let i = start; i < end; i++ ) {

                    const stmp = array[ i ];
                    const p = curve.getPointAt( stmp - Math.floor( stmp ) );
                    pos.setXYZ( i, p.x, p.y, p.z );

                }

                const points = curve.getPoints( 100 );
                const line = new THREE.LineLoop(
                    new THREE.BufferGeometry().setFromPoints( points ),
                    new THREE.LineBasicMaterial( { color: color[ idx ] } )
                );

                // group.add( line );
                lines.push( line );

            }

            pos.needsUpdate = true;


            const cameraPoints = [
                new THREE.Vector3( 0.3, -0.4, 2 ),
                new THREE.Vector3( 0, 0, 2 ),
                new THREE.Vector3( -0.3, 0.3, 2 ),
                new THREE.Vector3( -0.45, 0, 2 ),
                new THREE.Vector3( -0.3, -0.05, 2 ),
                new THREE.Vector3( 0, 0, 2 ),
                new THREE.Vector3( 0.3, 0.05, 2 ),
                new THREE.Vector3( 0.45, 0, 2 ),
            ];

            cameraCurve = new THREE.CatmullRomCurve3( cameraPoints );
            cameraCurve.curveType = 'centripetal';
            cameraCurve.closed = true;
            const camGeoPoints = cameraCurve.getPoints( 100 );
            const cameraLine = new THREE.LineLoop(
                new THREE.BufferGeometry().setFromPoints( camGeoPoints ),
                new THREE.LineBasicMaterial( { color: 0xffffff } )
            );
            // group.add( cameraLine );


            console.log( "complete" );

            init();
            animate();

            let lastDelay = 0;

            for ( let idx in lifes ) {

                const life = lifes[ idx ];

                let x = -life.position.x * 1.1;
                let y = life.position.y;
                let delay = Math.round( 10 * Math.random() + 5 );
                let duration = marineLifeAnimationDuration[ life.name ];

                if ( life.name === "GreenSeaTurtle" ) {

                    life.visible = false;

                    // y = -0.02;

                    // otherSetting.activateTurtle = () => {

                    //     let turtleTL = new gsap.timeline().fromTo( life.position, { x: life.position.x, y: life.position.y }, { x, y, duration } );

                    // };

                } else {

                    // otherSetting.activateWhale = () => {

                    //     let whaleTL = new gsap.timeline().fromTo( life.position, { x: life.position.x, y }, { x, y, duration } );

                    // };

                    let whaleTL = new gsap.timeline().fromTo( life.position, { x: life.position.x, y }, { x, y, duration } );

                }
                // gsap.to( life.position, { x, y, delay, duration } );
                lastDelay += delay;

            }


            otherFolder = gui.addFolder( "other" );
            otherFolder.add( otherSetting, "opacity", 0, 1, 0.001 ).onChange( () => particleMaterial.uniforms.opacityLimit.value = otherSetting.opacity );
            otherFolder.add( otherSetting, "turtleAppear" ).onChange( () => lifes[ 0 ].visible = otherSetting.turtleAppear );
            otherFolder.add( otherSetting, "whaleAppear" ).onChange( () => lifes[ 1 ].visible = otherSetting.whaleAppear );
            // otherFolder.addColor( lifes[ 0 ].children[ 0 ].children[ 1 ].material, "color" ).name( "TurtleColor" );
            // otherFolder.addColor( lifes[ 1 ].children[ 0 ].children[ 2 ].material, "color" ).name( "SpermWhaleColor" );
            otherFolder.add( otherSetting, "isFullScreen" ).onChange( ( val ) => {
                const leftBlock = document.querySelector( ".left-block" );
                const rightBlock = document.querySelector( ".right-block" );
                const opacity = val ? 0 : 1;
                leftBlock.style.opacity = opacity;
                rightBlock.style.opacity = opacity;
            } );
            otherFolder.add( otherSetting, "waveCamera" );
            // otherFolder.add( otherSetting, "activateTurtle" );
            // otherFolder.add( otherSetting, "activateWhale" );
            otherFolder.close();

            CustomEase.create( "camera", ".5, 0, .5, 1" );

            // if ( !config.cameraActive || false ) return;
            // if ( true ) return;

            const tl = new gsap.timeline( { repeat: -1 } )
                .fromTo(
                    timingObject,
                    { value: 0 },
                    {
                        value: 0.5,
                        duration: 10,
                        ease: "power4.inOut",
                        ease: "camera",
                        onUpdate: () => {
                            if ( !otherSetting.waveCamera ) return;
                            const cameraPosition = cameraCurve.getPointAt( timingObject.value );
                            camera.position.set( cameraPosition.x, cameraPosition.y, cameraPosition.z );
                            camera.lookAt( 0, 0, 0 );
                        }
                    }
                )
                .fromTo(
                    timingObject,
                    { value: 0.5 },
                    {
                        value: 1,
                        duration: 10,
                        ease: "power4.inOut",
                        ease: "camera",
                        onUpdate: () => {
                            if ( !otherSetting.waveCamera ) return;
                            const cameraPosition = cameraCurve.getPointAt( timingObject.value );
                            camera.position.set( cameraPosition.x, cameraPosition.y, cameraPosition.z );
                            camera.lookAt( 0, 0, 0 );
                        }
                    }
                );

        };


        let container, stats;
        let camera, scene, renderer;

        const BOUNDS = 3, BOUNDS_HALF = BOUNDS / 2;
        let last = performance.now();

        let gpuCompute;
        let positionVariable;
        let positionVariable2;
        let velocityVariable;
        let velocityVariable2;
        let positionUniforms;
        let positionUniforms2;
        let velocityUniforms;
        let velocityUniforms2;

        function init () {

            container = document.createElement( 'div' );
            container.style.borderLeft = `solid ${ leftBorderWidth }px #001224`;
            container.style.borderRight = `solid ${ rightBorderWidth }px #001224`;
            container.style.borderTop = `solid ${ topBorderWidth }px #001224`;
            container.style.borderBottom = `solid ${ bottomBorderWidth }px #001224`;
            container.style.touchAction = 'none';
            document.body.appendChild( container );


            camera = new THREE.PerspectiveCamera( 50, ( window.innerWidth - leftBorderWidth - rightBorderWidth ) / ( window.innerHeight - topBorderWidth - bottomBorderWidth ), 0.001, 1000 );
            camera.position.set( 0, 0, 2 );
            camera.lookAt( 0, 0, 0 );

            scene = new THREE.Scene();
            scene.background = new THREE.Color( backgroundObject.color );

            // LIGHTS
            const hemiLight = new THREE.HemisphereLight( lightObject.lightColor, lightObject.lightGroundColor, lightObject.lightIntensity );
            hemiLight.position.set( 0, 30, 0 );

            const planeGeometry = new THREE.PlaneGeometry( 5, 5 );
            const planeMaterial = new THREE.MeshBasicMaterial( { color: backgroundObject.filterColor, /** blending: THREE.AdditiveBlending */ } );
            const plane = new THREE.Mesh( planeGeometry, planeMaterial );
            plane.position.z = 1.95;
            plane.material.transparent = true;
            plane.material.opacity = backgroundObject.filterOpacity;

            const gridHelper = new THREE.GridHelper( 10, 20, 0xff0000, 0xffff00 );
            gridHelper.rotation.x = Math.PI * 0.5;
            // scene.add( gridHelper );

            // const screenMaterial = new THREE.MeshBasicMaterial( { color: 0x001224 } );
            // const leftPlane = new THREE.Mesh( planeGeometry, screenMaterial );
            // const rightPlane = new THREE.Mesh( planeGeometry, screenMaterial );
            // leftPlane.position.set( -2.6, 0, 1.95 );
            // rightPlane.position.set( 5, 0, 1.95 );
            // scene.add( leftPlane );
            // scene.add( rightPlane );

            for ( let i = 0; i < 4; i++ ) {

                const ballGeometry = new THREE.SphereGeometry( 0.01 );
                const ballMaterial = new THREE.MeshBasicMaterial( { color: 0xffffff } );
                const ball = new THREE.Mesh( ballGeometry, ballMaterial );

                ball.position.set( areaArr[ i ].x * 0.075, areaArr[ i ].y * 0.075, 0 );
                balls.push( ball );
                scene.add( ball );

            }


            renderer = new THREE.WebGLRenderer( { antialias: true, preserveDrawingBuffer: true } );
            renderer.setPixelRatio( Math.min( 2, window.devicePixelRatio ) );
            renderer.setSize( window.innerWidth - leftBorderWidth - rightBorderWidth, window.innerHeight - topBorderWidth - bottomBorderWidth );
            renderer.physicallyCorrectLights = true;
            renderer.toneMapping = toneMapping[ lightObject.toneMapping ];
            renderer.toneMappingExposure = lightObject.toneMappingExposure;
            renderer.outputEncoding = THREE.sRGBEncoding;
            container.appendChild( renderer.domElement );


            const orbitControl = new OrbitControls( camera, renderer.domElement );
            orbitControl.enableDamping = true;
            orbitControl.dampingFactor = 0.05;

            rgbeLoader.load( "./image/felsenlabyrinth.pic", ( hdrmap ) => {

                hdrmap.mapping = THREE.EquirectangularReflectionMapping;
                scene.environment = hdrmap;

            } );


            const geometry = new THREE.BufferGeometry();
            const vertices = [];


            const sprite2 = textureLoader.load( './image/particle/snowflake2.png' );
            const sprite3 = textureLoader.load( './image/particle/snowflake3.png' );
            const sprite4 = textureLoader.load( './image/particle/snowflake4.png' );
            const sprite5 = textureLoader.load( './image/particle/snowflake5.png' );

            const range = 2400;

            for ( let i = 0; i < floatingTotal; i++ ) {

                const x = Math.random() * range - range * 0.5;
                const y = Math.random() * range - range * 0.5;
                const z = Math.random() * range - range * 0.5;

                vertices.push( x, y, z );

            }

            geometry.setAttribute( 'position', new THREE.Float32BufferAttribute( vertices, 3 ) );

            const parameters = [
                [ [ 0.012, 0.071, 0.333 ], sprite2, 3 ],
                [ [ 0.125, 0.235, 0.349 ], sprite3, 1.5 ],
                [ [ 0.125, 0.235, 0.349 ], sprite4, 9 ],
                [ [ 0.5, 0.235, 0.349 ], sprite5, 9 ]
            ];

            const floatingGroup = new THREE.Group();

            for ( let i = 0; i < parameters.length; i++ ) {

                const color = parameters[ i ][ 0 ];
                const sprite = parameters[ i ][ 1 ];
                const size = parameters[ i ][ 2 ];

                floatingMaterials[ i ] = new THREE.PointsMaterial( { size: size, map: sprite, blending: THREE.AdditiveBlending, depthTest: true, depthWrite: false, transparent: true } );
                floatingMaterials[ i ].color.setHSL( color[ 0 ], color[ 1 ], color[ 2 ] );

                const seaFloatings = new THREE.Points( geometry, floatingMaterials[ i ] );

                seaFloatings.rotation.x = Math.random() * 6;
                seaFloatings.rotation.y = Math.random() * 6;
                seaFloatings.rotation.z = Math.random() * 6;

                floatingGroup.add( seaFloatings );
                floatings.push( seaFloatings );
            }


            initComputeRenderer();
            valuesChanger();
            initBirds( fishObject );


            floatingGroup.add( backgroundBird );
            floatingGroup.visible = false;

            scene.add( hemiLight );     // 半球光

            group.add( water );         // 海
            group.add( godrayMesh );    // 神聖光
            group.add( deepSea );       // 深海漸層
            group.add( floatingGroup ); // 背景生物
            group.add( whale );         // 大翅鯨
            group.add( birdMesh );      // 互動魚群
            group.add( particle );      // 大翅鯨粒子
            group.add( plane );         // 濾鏡
            scene.add( group );

            for ( let life of lifes ) {
                group.add( life );
            }


            stats = new Stats();
            container.appendChild( stats.dom );

            gui = new GUI();

            const backgroundFolder = gui.addFolder( 'background' );
            backgroundFolder.addColor( backgroundObject, 'color' ).onChange( () => {
                scene.background = new THREE.Color( backgroundObject.color );
                waterMaterial.uniforms.uFogColor.value.set( backgroundObject.color );
            } );
            backgroundFolder.addColor( backgroundObject, "filterColor" ).onChange( () => {
                plane.material.color = new THREE.Color( backgroundObject.filterColor );
            } );
            backgroundFolder.add( backgroundObject, "filterOpacity", 0, 1, 0.01 ).onChange( () => {
                plane.material.opacity = backgroundObject.filterOpacity;
            } );
            backgroundFolder.close();

            const lightFolder = gui.addFolder( "light" );
            lightFolder.addColor( lightObject, "lightColor" ).onChange( () => {
                hemiLight.color.setHex( lightObject.lightColor );
            } );
            lightFolder.addColor( lightObject, "lightGroundColor" ).onChange( () => {
                hemiLight.color.setHex( lightObject.lightGroundColor );
            } );
            lightFolder.add( lightObject, "lightIntensity", 0, 10, 0.001 ).onChange( () => {
                hemiLight.intensity = lightObject.lightIntensity;
            } );
            lightFolder.add( lightObject, "toneMapping", [ "No", "Linear", "Reinhard", "Cineon", "ACESFilmic" ] ).onChange( () => {
                renderer.toneMapping = toneMapping[ lightObject.toneMapping ];
            } );
            lightFolder.add( lightObject, "toneMappingExposure", 0, 1, 0.001 ).onChange( () => {
                renderer.toneMappingExposure = lightObject.toneMappingExposure;
            } );
            lightFolder.close();

            const waterFolder = gui.addFolder( 'water' );
            waterFolder.add( waterMaterial.uniforms.uBigWavesElevation, 'value' ).min( 0 ).max( 1 ).step( 0.001 ).name( 'uBigWavesElevation' );
            waterFolder.add( waterMaterial.uniforms.uBigWavesSpeed, 'value' ).min( 0 ).max( 4 ).step( 0.001 ).name( 'uBigWavesSpeed' );
            waterFolder.add( waterMaterial.uniforms.uBigWavesFrequency.value, 'x' ).min( 0 ).max( 10 ).step( 0.01 ).name( 'uBigWavesFrequency.x' );
            waterFolder.add( waterMaterial.uniforms.uBigWavesFrequency.value, 'y' ).min( 0 ).max( 10 ).step( 0.01 ).name( 'uBigWavesFrequency.y' );
            waterFolder.add( waterMaterial.uniforms.uSmallWavesElevation, 'value' ).min( 0 ).max( 1 ).step( 0.001 ).name( 'uSmallWavesElevation' );
            waterFolder.add( waterMaterial.uniforms.uSmallWavesFrequency, 'value' ).min( 0 ).max( 30 ).step( 0.001 ).name( 'uSmallWavesFrequency' );
            waterFolder.add( waterMaterial.uniforms.uSmallWavesSpeed, 'value' ).min( 0 ).max( 4 ).step( 0.001 ).name( 'uSmallWavesSpeed' );
            waterFolder.add( waterMaterial.uniforms.uSmallWavesInteraction, 'value' ).min( 0 ).max( 30 ).step( 1 ).name( 'uSmallWavesInteraction' );
            waterFolder.addColor( waterObject, 'depthColor' ).name( 'depthColor' ).onChange( () => {
                waterMaterial.uniforms.uDepthColor.value.set( waterObject.depthColor );
            } );
            waterFolder.addColor( waterObject, 'surfaceColor' ).name( 'surfaceColor' ).onChange( () => {
                waterMaterial.uniforms.uSurfaceColor.value.set( waterObject.surfaceColor );
            } );
            waterFolder.add( waterMaterial.uniforms.uColorOffset, 'value' ).min( 0 ).max( 1 ).step( 0.001 ).name( 'uColorOffset' );
            waterFolder.add( waterMaterial.uniforms.uColorMultiplier, 'value' ).min( 0 ).max( 10 ).step( 0.001 ).name( 'uColorMultiplier' );
            waterFolder.close();

            const deepSeaFolder = gui.addFolder( "deepSea" );
            deepSeaFolder.addColor( deepSea.material.uniforms.color1, "value" ).name( "deepSeaColor1" );
            deepSeaFolder.addColor( deepSea.material.uniforms.color2, "value" ).name( "deepSeaColor2" );
            deepSeaFolder.add( deepSea.material.uniforms.alpha, "value", 0, 1, 0.001 ).name( "opacity" );
            deepSeaFolder.add( deepSeaObject, "offsetX", -5, 5, 0.001 ).onChange( () => {
                deepSea.material.uniforms.offset.value = new THREE.Vector2( deepSeaObject.offsetX, deepSeaObject.offsetY );
            } );
            deepSeaFolder.add( deepSeaObject, "offsetY", -10, 10, 0.001 ).onChange( () => {
                deepSea.material.uniforms.offset.value = new THREE.Vector2( deepSeaObject.offsetX, deepSeaObject.offsetY );
            } );
            deepSeaFolder.add( deepSeaObject, "scaleX", 0, 5, 0.001 ).onChange( () => {
                deepSea.material.uniforms.scale.value = new THREE.Vector2( deepSeaObject.scaleX, deepSeaObject.scaleY );
            } );
            deepSeaFolder.add( deepSeaObject, "scaleY", 0, 5, 0.001 ).onChange( () => {
                deepSea.material.uniforms.scale.value = new THREE.Vector2( deepSeaObject.scaleX, deepSeaObject.scaleY );
            } );
            deepSeaFolder.close();

            const whaleFolder = gui.addFolder( "whale" );
            whaleFolder.add( whaleObject, "size", 0, 0.2, 0.001 ).onChange( () => whale.scale.set( whaleObject.size, whaleObject.size, whaleObject.size ) );
            whaleFolder.add( whaleObject, "x", -0.5, 0.5, 0.001 ).onChange( () => whale.position.x = whaleObject.x );
            whaleFolder.add( whaleObject, "y", -0.5, 0.5, 0.001 ).onChange( () => whale.position.y = whaleObject.y );
            whaleFolder.add( whaleObject, "particleCount1", 0, countArr[ 1 ] - countArr[ 0 ], 1 ).onChange( valuesChanger );
            whaleFolder.add( whaleObject, "particleCount2", 0, countArr[ 2 ] - countArr[ 1 ], 1 ).onChange( valuesChanger );
            whaleFolder.add( whaleObject, "particleCount3", 0, countArr[ 3 ] - countArr[ 2 ], 1 ).onChange( valuesChanger );
            whaleFolder.add( whaleObject, "particleCount4", 0, countArr[ 4 ] - countArr[ 3 ], 1 ).onChange( valuesChanger );
            whaleFolder.add( whaleObject, "showPic" );
            whaleFolder.add( whaleObject, "makeWhaleSpin" );
            whaleFolder.close();

            const fishFolder = gui.addFolder( "fish" );
            fishFolder.add( fishObject, "separation", 0.0, 100.0, 0.001 ).onChange( valuesChanger );
            fishFolder.add( fishObject, "alignment", 0.0, 10000, 1.0 ).onChange( valuesChanger );
            fishFolder.add( fishObject, "cohesion", 0.0, 10000, 1.0 ).onChange( valuesChanger );
            fishFolder.add( fishObject, "size", 0, 100, 0.01 ).onChange( valuesChanger );
            fishFolder.add( fishObject, "count", 0, BIRDS, 1 ).onChange( valuesChanger );
            fishFolder.add( fishObject, "colorR", -1, 1, 0.001 ).onChange( () => {
                if ( materialShader ) materialShader.uniforms.colorR.value = fishObject.colorR;
            } );
            fishFolder.add( fishObject, "colorG", -1, 1, 0.001 ).onChange( () => {
                if ( materialShader ) materialShader.uniforms.colorG.value = fishObject.colorG;
            } );
            fishFolder.add( fishObject, "colorB", -1, 1, 0.001 ).onChange( () => {
                if ( materialShader ) materialShader.uniforms.colorB.value = fishObject.colorB;
            } );
            fishFolder.add( fishObject, "centerX", -10, 10, 0.001 ).onChange( setCenter );
            fishFolder.add( fishObject, "centerY", -10, 10, 0.001 ).onChange( setCenter );
            fishFolder.add( fishObject, "centerZ", -10, 10, 0.001 ).onChange( setCenter );
            fishFolder.add( fishObject, "centering", 0, 4000, 1 ).onChange( () => {
                velocityUniforms[ "centering" ].value = fishObject.centering;
            } );
            fishFolder.close();

            const floatingFolder = gui.addFolder( "floating" );
            floatingFolder.add( floatingObject, "size", 0, 10, 0.001 ).onChange( floatingSetting );
            floatingFolder.add( floatingObject, "z", -2400, 2400, 0.1 ).onChange( floatingSetting );
            floatingFolder.close();

            const backgroundFishFolder = gui.addFolder( "backgroundFish" );
            backgroundFishFolder.add( backgroundFishObject, "separation2", 0.0, 100.0, 0.001 ).onChange( valuesChanger );
            backgroundFishFolder.add( backgroundFishObject, "alignment2", 0.0, 10000, 1.0 ).onChange( valuesChanger );
            backgroundFishFolder.add( backgroundFishObject, "cohesion2", 0.0, 10000, 1.0 ).onChange( valuesChanger );
            backgroundFishFolder.add( backgroundFishObject, "size2", 0, 100, 0.01 ).onChange( valuesChanger );
            backgroundFishFolder.add( backgroundFishObject, "count2", 0, BIRDS, 1 ).onChange( valuesChanger );
            backgroundFishFolder.close();

            gui.close();

            setInterval( intervalExe, 1000 );

            const ctrl = document.querySelector( ".lil-gui" );
            const countText = document.querySelector( ".info" );
            stats.dom.style.display = debug ? "block" : "none";
            ctrl.style.display = debug ? "block" : "none";
            countText.style.display = debug ? "block" : "none";
            balls.forEach( item => {
                item.visible = debug;
            } );

            group.children.forEach( child => {
                child.visible = true;
            } );

            window.addEventListener( 'pointermove', onMouseMove );
            window.addEventListener( 'resize', onWindowResize );
            // window.addEventListener( "keypress", ( event ) => {

            //     const numArr = [ "1", "2", "3", "4", "5", "6", "7", "8" ];

            //     if ( numArr.indexOf( event.key ) >= 0 ) {
            //         group.children[ event.key - 0 - 1 ].visible = true;
            //     }

            //     if ( event.key === " " ) {
            //         debug = !debug;
            //     }

            //     if ( !debug ) return;

            //     if ( event.key === "Enter" ) {

            //         event.preventDefault();

            //         if ( !stats.dom.style.display || stats.dom.style.display === "block" ) {
            //             stats.dom.style.display = "none";
            //         } else {
            //             stats.dom.style.display = "block";
            //         }

            //         if ( !ctrl.style.display || ctrl.style.display === "block" ) {
            //             ctrl.style.display = "none";
            //         } else {
            //             ctrl.style.display = "block";
            //         }

            //         if ( !countText.style.display || countText.style.display === "block" ) {
            //             countText.style.display = "none";
            //         } else {
            //             countText.style.display = "block";
            //         }

            //         // balls.forEach( item => {

            //         //     let bool = item.visible;
            //         //     item.visible = !bool;

            //         // } );

            //     }

            // } );

        }


        function setCenter () {

            const { centerX, centerY, centerZ } = fishObject;

            if ( materialShader ) velocityUniforms[ "central" ].value.set( centerX, centerY, centerZ );

        }


        function intervalExe () {

            interval++;

            getData();
            getSpinStatus();
            if ( interval % 30 === 0 ) savePic();
            if ( interval % 3600 === 0 ) location.reload();

        }


        function getData () {

            let datas;

            apiGetPeopleData()
                .then( ( res ) => {

                    if ( res && res.data && res.data.data && res.data.message === "Success!" ) {

                        dataLoop = false;
                        datas = res.data.data;

                    } else {

                        dataLoop = true;
                        throw new Error();

                    }

                } )
                .catch( ( error ) => {

                    dataLoop = true;

                    if ( dataLoop ) {
                        datas = data[ d ];
                    }

                } )
                .finally( () => {

                    const alphas = particle.geometry.getAttribute( "alpha" );

                    areaCount[ 0 ] = 0;
                    areaCount[ 1 ] = 0;
                    areaCount[ 2 ] = 0;
                    areaCount[ 3 ] = 0;

                    datas.forEach( item => {
                        areaCount[ resArea[ item.Area - 0 - 1 ] ]++;
                    } );

                    whaleObject.particleCount1 = areaCount[ 0 ] * 5;
                    whaleObject.particleCount2 = areaCount[ 1 ] * 5;
                    whaleObject.particleCount3 = areaCount[ 2 ] * 5;
                    whaleObject.particleCount4 = areaCount[ 3 ] * 5;

                    let { particleCount1, particleCount2, particleCount3, particleCount4, particleCount5Lowest } = whaleObject;
                    let all = particleCount1 + particleCount2 + particleCount3 + particleCount4;
                    let base = countArr[ 5 ] - countArr[ 4 ] - particleCount5Lowest;

                    whaleObject.particleCount5 = particleCount5Lowest + Math.floor( all * base / countArr[ 4 ] );
                    areaCount[ 4 ] = whaleObject.particleCount5;

                    whaleObject.particleCountArray[ 0 ] = { value: lastAreaCount[ 0 ] * 5 };
                    whaleObject.particleCountArray[ 1 ] = { value: lastAreaCount[ 1 ] * 5 };
                    whaleObject.particleCountArray[ 2 ] = { value: lastAreaCount[ 2 ] * 5 };
                    whaleObject.particleCountArray[ 3 ] = { value: lastAreaCount[ 3 ] * 5 };
                    whaleObject.particleCountArray[ 4 ] = { value: lastAreaCount[ 4 ] };

                    // maxArea = [ particleCount1, particleCount2, particleCount3, particleCount4 ].indexOf( Math.max( particleCount1, particleCount2, particleCount3, particleCount4 ) );

                    if ( d % 20 === 0 ) {
                        maxArea = Math.floor( Math.random() * 4 );
                    }

                    // if ( materialShader ) velocityUniforms[ "central" ].value.set( areaArr[ maxArea ].x, areaArr[ maxArea ].y, 0 );


                    for ( let i = 0; i < curveRoads.length; i++ ) {

                        let start = amount * countArr[ i ],
                            end = amount * countArr[ i + 1 ];

                        if ( areaCount[ i ] !== lastAreaCount[ i ] ) {

                            gsap.fromTo(
                                whaleObject.particleCountArray[ i ],
                                { value: lastAreaCount[ i ] * ( i === 4 ? 1 : 5 ) },
                                {
                                    value: areaCount[ i ] * ( i === 4 ? 1 : 5 ),
                                    duration: 1,
                                    ease: "linear",
                                    onUpdate: () => {

                                        const opacity = whaleObject.particleCountArray[ i ].value * otherSetting.opacity / ( ( end - start ) / amount );

                                        for ( let j = start; j < end; j++ ) {

                                            alphas.array[ j ] = opacity;

                                        }

                                        alphas.needsUpdate = true;

                                    },
                                    onComplete: () => {

                                        lastAreaCount[ i ] = areaCount[ i ];

                                    }
                                }
                            );

                        }

                    }

                    if ( debug ) {

                        const texts = document.querySelectorAll( ".block" );
                        texts.forEach( ( item, idx ) => {
                            item.innerText = areaCount[ idx ];
                        } );

                        const text = document.getElementById( "block-all" );
                        text.innerText = datas.length;

                        balls.forEach( item => {
                            item.material.color = new THREE.Color( 0xffffff );
                        } );
                        balls[ maxArea ].material.color = new THREE.Color( 0x0000ff );

                    }

                    d++;
                    if ( d >= 425 ) d = 0;

                } );

        }


        function getSpinStatus () {

            if ( status !== "Spinning" ) {

                apiGetSpinStatus()
                    .then( ( res ) => {

                        if ( res && res.data && res.data.message === "Success!" ) {

                            spinLoop = false;

                            if ( res.data.data === "Spin now!" ) {

                                status = "Spinning";

                                gsap.fromTo(

                                    whale.rotation,
                                    { y: 0 },
                                    {
                                        y: Math.PI * 2,
                                        ease: "linear",
                                        duration: 90,
                                        onUpdate: function () {

                                            let xSpin = this.progress() * 2 * Math.PI;
                                            whale.rotation.x = Math.PI * 0.3 * Math.sin( -xSpin );

                                        },
                                        onComplete: () => {

                                            apiGetSpinStatus()
                                                .then( ( res ) => {

                                                    if ( res && res.data && res.data.message === "Success!" ) {

                                                        spinLoop = false;
                                                        status = "Status is normal, no one call spin!";

                                                    } else {

                                                        spinLoop = true;
                                                        throw new Error();
                                                    }

                                                } )
                                                .catch( ( error ) => {

                                                    spinLoop = true;

                                                    if ( spinLoop ) {
                                                        console.log( error );
                                                    }

                                                } );
                                        }
                                    }

                                );
                            }

                        } else {

                            spinLoop = true;
                            throw new Error();
                        }

                    } )
                    .catch( ( error ) => {

                        spinLoop = true;

                        if ( spinLoop ) {
                            console.log( error );
                        }

                    } );

            }

        }


        function savePic () {

            const canvas = document.querySelector( "canvas" );
            const image = canvas.toDataURL( "image/jpeg", 1.0 );

            apiPostPicSave( { Base64String: image } )
                .then( ( res ) => {

                    if ( res && res.data && res.data.message === "Success!" ) {

                        imageLoop = false;

                    } else {

                        imageLoop = true;
                        throw new Error();

                    }

                } )
                .catch( ( error ) => {

                    imageLoop = true;

                    if ( imageLoop ) {
                        console.log( error );
                    }

                } );

        }

        function makeWhaleSpin () {

            apiPostSpinStatus( {} ).then( ( res ) => { } );
        }

        function showPic () {

            let imageDOM, image;

            if ( document.querySelector( "img" ) ) {

                imageDOM = document.querySelector( "img" );

            } else {

                imageDOM = document.createElement( "img" );
                document.body.appendChild( imageDOM );
            }

            apiGetPicSaved()
                .then( ( res ) => {

                    if ( res.data.message === "Success!" ) {

                        image = res.data.base64Str;
                        imageDOM.src = image;
                        alert( "Get Image!" );

                    } else {

                        throw new Error( res );

                    }
                } )
                .catch( ( error ) => console.log( error ) );

        }

        function floatingSetting () {

            for ( let f of floatings ) {

                f.scale.set( floatingObject.size, floatingObject.size, floatingObject.size );
                f.position.z = floatingObject.z;
            }

        }


        function valuesChanger () {

            velocityUniforms[ "separationDistance" ].value = fishObject.separation;
            velocityUniforms[ "alignmentDistance" ].value = fishObject.alignment;
            velocityUniforms[ "cohesionDistance" ].value = fishObject.cohesion;
            velocityUniforms[ "freedomFactor" ].value = fishObject.freedom;
            if ( materialShader ) materialShader.uniforms[ "size" ].value = fishObject.size;

            velocityUniforms2[ "separationDistance" ].value = backgroundFishObject.separation2;
            velocityUniforms2[ "alignmentDistance" ].value = backgroundFishObject.alignment2;
            velocityUniforms2[ "cohesionDistance" ].value = backgroundFishObject.cohesion2;
            velocityUniforms2[ "freedomFactor" ].value = backgroundFishObject.freedom2;
            if ( materialShader2 ) materialShader2.uniforms[ "size" ].value = backgroundFishObject.size2;

            BirdGeometry.setDrawRange( 0, indicesPerBird * fishObject.count );
            if ( backgroundBird ) backgroundBird.geometry.setDrawRange( 0, indicesPerBird * backgroundFishObject.count2 );

            let { particleCount1, particleCount2, particleCount3, particleCount4, particleCount5, particleCount5Lowest } = whaleObject;
            let all = particleCount1 + particleCount2 + particleCount3 + particleCount4;
            let base = countArr[ 5 ] - countArr[ 4 ] - particleCount5Lowest;
            particleCount5 = particleCount5Lowest + Math.floor( all * base / countArr[ 4 ] );
            whaleObject.particleCountArray = [
                { value: particleCount1 },
                { value: particleCount2 },
                { value: particleCount3 },
                { value: particleCount4 },
                { value: particleCount5 }
            ];

        };


        function initComputeRenderer () {

            gpuCompute = new GPUComputationRenderer( WIDTH, WIDTH, renderer );

            if ( renderer.capabilities.isWebGL2 === false ) {

                gpuCompute.setDataType( THREE.HalfFloatType );

            }

            const dtPosition = gpuCompute.createTexture();
            const dtVelocity = gpuCompute.createTexture();
            fillPositionTexture( dtPosition );
            fillVelocityTexture( dtVelocity );

            positionVariable = gpuCompute.addVariable( "texturePosition", positionShader, dtPosition );
            velocityVariable = gpuCompute.addVariable( "textureVelocity", velocityShader, dtVelocity );
            positionVariable2 = gpuCompute.addVariable( "texturePosition", positionShader, dtPosition );
            velocityVariable2 = gpuCompute.addVariable( "textureVelocity", velocityShader2, dtVelocity );

            gpuCompute.setVariableDependencies( positionVariable, [ positionVariable, velocityVariable ] );
            gpuCompute.setVariableDependencies( velocityVariable, [ positionVariable, velocityVariable ] );
            gpuCompute.setVariableDependencies( positionVariable2, [ positionVariable2, velocityVariable2 ] );
            gpuCompute.setVariableDependencies( velocityVariable2, [ positionVariable2, velocityVariable2 ] );

            positionUniforms = positionVariable.material.uniforms;
            velocityUniforms = velocityVariable.material.uniforms;
            positionUniforms2 = positionVariable2.material.uniforms;
            velocityUniforms2 = velocityVariable2.material.uniforms;

            positionUniforms[ "time" ] = { value: 0.0 };
            positionUniforms[ "delta" ] = { value: 0.0 };

            positionUniforms2[ "time" ] = { value: 0.0 };
            positionUniforms2[ "delta" ] = { value: 0.0 };

            velocityUniforms[ "time" ] = { value: 1.0 };
            velocityUniforms[ "delta" ] = { value: 0.0 };
            velocityUniforms[ "testing" ] = { value: 1.0 };
            velocityUniforms[ "separationDistance" ] = { value: fishObject.separation };
            velocityUniforms[ "alignmentDistance" ] = { value: fishObject.alignment };
            velocityUniforms[ "cohesionDistance" ] = { value: fishObject.cohesion };
            velocityUniforms[ "freedomFactor" ] = { value: fishObject.freedom };
            velocityUniforms[ "predator" ] = { value: new THREE.Vector3( fishObject.centerX, fishObject.centerY, fishObject.centerZ ) };
            velocityUniforms[ "central" ] = { value: new THREE.Vector3( fishObject.centerX, fishObject.centerY, fishObject.centerZ ) };
            velocityUniforms[ "centering" ] = { value: fishObject.centering };
            velocityVariable.material.defines.BOUNDS = BOUNDS.toFixed( 2 );

            velocityUniforms2[ "time" ] = { value: 1.0 };
            velocityUniforms2[ "delta" ] = { value: 0.0 };
            velocityUniforms2[ "testing" ] = { value: 1.0 };
            velocityUniforms2[ "separationDistance" ] = { value: fishObject.separation2 };
            velocityUniforms2[ "alignmentDistance" ] = { value: fishObject.alignment2 };
            velocityUniforms2[ "cohesionDistance" ] = { value: fishObject.cohesion2 };
            velocityUniforms2[ "freedomFactor" ] = { value: fishObject.freedom2 };
            velocityUniforms2[ "predator" ] = { value: new THREE.Vector3( 0, 0, 0 ) };
            velocityUniforms2[ "central" ] = { value: new THREE.Vector3( 0, 0, 0 ) };
            velocityUniforms2[ "centering" ] = { value: fishObject.centering };
            velocityVariable2.material.defines.BOUNDS = BOUNDS.toFixed( 2 );

            positionVariable.wrapS = THREE.RepeatWrapping;
            positionVariable.wrapT = THREE.RepeatWrapping;

            positionVariable2.wrapS = THREE.RepeatWrapping;
            positionVariable2.wrapT = THREE.RepeatWrapping;

            velocityVariable.wrapS = THREE.RepeatWrapping;
            velocityVariable.wrapT = THREE.RepeatWrapping;

            velocityVariable2.wrapS = THREE.RepeatWrapping;
            velocityVariable2.wrapT = THREE.RepeatWrapping;


            const error = gpuCompute.init();

            if ( error !== null ) {

                console.error( error );

            }

        }


        function initBirds () {

            const texture = textureLoader.load( "./image/fish-texture.jpg" );
            const geometry = BirdGeometry;
            const bgGeometry = geometry.clone();

            materialShader = new THREE.ShaderMaterial( {

                uniforms: {

                    texturePosition: { value: null },
                    textureVelocity: { value: null },
                    textureAnimation: { value: textureAnimation },
                    time: { value: 1.0 },
                    size: { value: fishObject.size },
                    delta: { value: 0.0 },
                    fishTexture: { value: texture },
                    colorR: { value: fishObject.colorR },
                    colorG: { value: fishObject.colorG },
                    colorB: { value: fishObject.colorB }

                },

                vertexShader: fishVertex,
                fragmentShader: fishFragment,

            } );

            materialShader2 = new THREE.ShaderMaterial( {

                uniforms: {

                    texturePosition: { value: null },
                    textureVelocity: { value: null },
                    textureAnimation: { value: textureAnimation },
                    time: { value: 1.0 },
                    size: { value: backgroundFishObject.size2 },
                    delta: { value: 0.0 },
                    fishTexture: { value: texture },
                    colorR: { value: fishObject.colorR },
                    colorG: { value: fishObject.colorG },
                    colorB: { value: fishObject.colorB }

                },

                vertexShader: fishVertex,
                fragmentShader: fishFragment,

            } );


            birdMesh = new THREE.Mesh( geometry, materialShader );
            birdMesh.scale.set( 0.1, 0.1, 0.1 );
            birdMesh.position.z = -1;
            birdMesh.visible = false;
            // group.add( birdMesh );

            bgGeometry.setDrawRange( 0, indicesPerBird * backgroundFishObject.count2 );
            backgroundBird = new THREE.Mesh( bgGeometry, materialShader2 );
            backgroundBird.scale.set( 0.09, 0.09, 0.09 );
            backgroundBird.position.set( 0, 0, -2 );
            // group.add( backgroundBird );

        }

        function fillPositionTexture ( texture ) {

            const theArray = texture.image.data;

            for ( let k = 0, kl = theArray.length; k < kl; k += 4 ) {

                const x = Math.random() * BOUNDS - BOUNDS_HALF;
                const y = Math.random() * BOUNDS - BOUNDS_HALF;
                const z = Math.random() * BOUNDS - BOUNDS_HALF;

                theArray[ k + 0 ] = x;
                theArray[ k + 1 ] = y;
                theArray[ k + 2 ] = z;
                theArray[ k + 3 ] = 1;

            }

        }

        function fillVelocityTexture ( texture ) {

            const theArray = texture.image.data;

            for ( let k = 0, kl = theArray.length; k < kl; k += 4 ) {

                const x = Math.random() - 0.5;
                const y = Math.random() - 0.5;
                const z = Math.random() - 0.5;

                theArray[ k + 0 ] = x * 10;
                theArray[ k + 1 ] = y * 10;
                theArray[ k + 2 ] = z * 10;
                theArray[ k + 3 ] = 1;

            }

        }

        function onMouseMove ( e ) {

            let vector = new THREE.Vector3();
            vector.set( ( ( e.clientX / window.innerWidth ) * 2 - 1 ) * 25, ( -( e.clientY / window.innerHeight ) * 2 + 1 ) * 13, 0 );
            // vector.unproject( camera );
            if ( materialShader ) velocityUniforms[ "central" ].value.set( vector.x, vector.y, 0 );
            // console.log( vector );

        }


        function onWindowResize ( bool ) {

            // if ( bool ) {

            //     leftBorderWidth = 0;
            //     rightBorderWidth = 0;

            // } else {

            //     leftBorderWidth = ( window.innerWidth - window.innerHeight * 9 / 16 ) / 2;
            //     rightBorderWidth = ( window.innerWidth - window.innerHeight * 9 / 16 ) / 2;
            // }

            leftBorderWidth = window.innerWidth < 568 ? 0 : ( window.innerWidth - window.innerHeight * 9 / 16 ) / 2;
            rightBorderWidth = window.innerWidth < 568 ? 0 : ( window.innerWidth - window.innerHeight * 9 / 16 ) / 2;

            container.style.borderLeft = `solid ${ leftBorderWidth }px #001224`;
            container.style.borderRight = `solid ${ rightBorderWidth }px #001224`;
            container.style.borderTop = `solid ${ topBorderWidth }px #001224`;
            container.style.borderBottom = `solid ${ bottomBorderWidth }px #001224`;

            camera.aspect = ( window.innerWidth - leftBorderWidth - rightBorderWidth ) / ( window.innerHeight - topBorderWidth - bottomBorderWidth );
            camera.updateProjectionMatrix();
            renderer.setSize( window.innerWidth - leftBorderWidth - rightBorderWidth, window.innerHeight - topBorderWidth - bottomBorderWidth );

        }


        function animate () {

            requestAnimationFrame( animate );
            render();
            stats.update();

        }

        function render () {

            const now = performance.now() / ratio;
            let delta = ( now - last ) / 1000;


            // safety cap on large deltas
            if ( delta > 1 ) delta = 1;
            last = now;

            // whale animation ( body + cube )
            mixer.update( delta * 2 );

            for ( let animalMixer of mixers ) {
                animalMixer.update( delta * 8 );
            }

            // update particle
            particleMaterial.uniforms.time.value = now / 1000;
            // update water
            waterMaterial.uniforms.uTime.value = now / 1000;
            // update ray
            godrayMaterial.uniforms.uTime.value = now / 1000;


            // sea floating update
            for ( let i = 0; i < floatings.length; i++ ) {

                const object = floatings[ i ];
                object.rotation.y = now * ( i < 4 ? i + 1 : - ( i + 1 ) ) * 0.003 / 1000;

            }


            // update position and velocity
            positionUniforms[ "time" ].value = now;
            positionUniforms[ "delta" ].value = delta;
            velocityUniforms[ "time" ].value = now;
            velocityUniforms[ "delta" ].value = delta;

            positionUniforms2[ "time" ].value = now;
            positionUniforms2[ "delta" ].value = delta;
            velocityUniforms2[ "time" ].value = now;
            velocityUniforms2[ "delta" ].value = delta;

            gpuCompute.compute();

            // update texture
            if ( materialShader ) materialShader.uniforms[ "time" ].value = now / 1000;
            if ( materialShader ) materialShader.uniforms[ "delta" ].value = delta;
            if ( materialShader ) materialShader.uniforms[ "texturePosition" ].value = gpuCompute.getCurrentRenderTarget( positionVariable ).texture;
            if ( materialShader ) materialShader.uniforms[ "textureVelocity" ].value = gpuCompute.getCurrentRenderTarget( velocityVariable ).texture;

            if ( materialShader2 ) materialShader2.uniforms[ "time" ].value = now / 1000;
            if ( materialShader2 ) materialShader2.uniforms[ "delta" ].value = delta;
            if ( materialShader2 ) materialShader2.uniforms[ "texturePosition" ].value = gpuCompute.getCurrentRenderTarget( positionVariable2 ).texture;
            if ( materialShader2 ) materialShader2.uniforms[ "textureVelocity" ].value = gpuCompute.getCurrentRenderTarget( velocityVariable2 ).texture;


            // update cube position
            meshes.forEach( mesh => {

                const { segment, sIndex } = mesh;
                let curvePoint = new THREE.Vector3();
                initialPoints[ segment ][ sIndex ] = whale.localToWorld( curvePoint.copy( mesh.position ) );

            } );

            // update particle position and quantity
            let vIndex = 10;

            const pos = particle.geometry.getAttribute( "position" );
            const { array } = particle.geometry.getAttribute( "velocity" );

            if ( now > 100 ) {
                vIndex = 0.00006;
            }

            // update curve and particle speed
            for ( let i = 0; i < curveRoads.length; i++ ) {

                let curve = new THREE.CatmullRomCurve3( initialPoints[ i ] );
                curveRoads[ i ] = curve;
                lines[ i ].geometry.setFromPoints( curve.getPoints( 200 ) );

                let start = amount * countArr[ i ],
                    end = amount * countArr[ i + 1 ];

                for ( let j = start; j < end; j++ ) {

                    array[ j ] += 0.01 * Math.random() * vIndex + vIndex;

                    const stmp = array[ j ];
                    const p = curve.getPointAt( stmp - Math.floor( stmp ) );

                    pos.setXYZ( j, p.x, p.y, p.z );

                }

            }

            pos.needsUpdate = true;

            renderer.render( scene, camera );

        }

    } );